import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationRoundsPage } from "src/components/views/erp/reclamation/rounds/ReclamationRoundsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/rounds")({
	staticData: { title: i18n.t("reclamation_rounds"), legacyViewKey: "reclamationRoundsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationRoundsPage />;
}
